/**
 * MapIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const MapIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M14.132 3.39a2.76 2.76 0 0 1 1.738.002l4.683 1.56.132.05a1.75 1.75 0 0 1 1.065 1.611v12.005a1.75 1.75 0 0 1-2.533 1.565l-3.657-1.83a1.3 1.3 0 0 0-.478-.128 1 1 0 0 1-.163 0 1.3 1.3 0 0 0-.343.07l-.135.058-4.21 2.107-.002-.001a2.75 2.75 0 0 1-2.458 0l-4.553-2.275a1.75 1.75 0 0 1-.968-1.566V5.28a1.75 1.75 0 0 1 2.304-1.66h-.001l4.051 1.35q.178.058.363.062h.065q.185-.004.363-.062l4.735-1.58zM4.078 5.04a.25.25 0 0 0-.328.238v11.34c0 .093.053.18.139.223l4.361 2.18V6.426l-.12-.034zm5.791 1.35c-.04.014-.08.023-.119.035v12.596l4.02-2.01q.233-.117.48-.186V4.931zm5.881 10.435q.247.07.48.186l3.659 1.829a.25.25 0 0 0 .361-.223V6.613a.25.25 0 0 0-.17-.237l-4.33-1.443z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const MapIcon = makeIcon('MapIcon', MapIconSvg)
